module.exports = __webpack_public_path__ + "img/arrowDown.0b3cb606.svg";